import linkifyString from 'linkifyjs/lib/linkify-string';
const currentHost = `${location.protocol}//${location.host}`;

export default function linky() {
  return function link(input, target) {
    return linkifyString(input, {
      linkAttributes: {
        rel: 'noopener',
      },
      target(href = '', type = '') {
        return type === 'url' && href.indexOf(currentHost) !== 0 ? target : null;
      },
    });
  };
}
